import { observer } from 'mobx-react-lite'
import React from 'react'
import { IconButton } from 'shared/ui'
import { useShare } from 'shared/hooks'

type IReferralsLinkProps = {
  icon: 'facebook' | 'twitter' | 'linkedin'
  ariaLabel: string
  className: string
  link: string
}

export const ReferralsLink = observer(
  ({ icon, ariaLabel, className, link }: IReferralsLinkProps) => {
    const { canShare, share } = useShare({
      network: icon,
      url: link,
      title:
        'If you’re tired of chasing leads by phone or email, Salesmsg makes it super easy to text them instead. I’ve been using it and love it—grab it here with my link.',
      hashtags: ['salesmsg'],
    })

    const handleClick = () => {
      if (canShare && link) {
        share()
      }
    }

    if (!link) {
      return null
    }

    return (
      <IconButton
        icon={icon}
        iconProps={{ fontSize: 24 }}
        size='small'
        variant='icon'
        onClick={handleClick}
        ariaLabel={ariaLabel}
        color='noop'
        className={className}
        tooltipProps={{ label: `Share on ${icon}`, placement: 'top' }}
        disabled={!canShare}
      />
    )
  }
)
